import { FC, lazy, Suspense } from 'react';

import { SkeletonLoader } from 'components/_basic/SkeletonLoader';

const OnePageThirdStyleViewLazy = lazy(() => import('./OnePageThirdStyle'));

export const OnePageThirdStyleView: FC = () => {
  return (
    <Suspense fallback={<SkeletonLoader />}>
      <OnePageThirdStyleViewLazy />
    </Suspense>
  );
};
